export default function PHP_ftp_nb_fput() {
  return (
    <div>
      <h1>PHP_ftp_nb_fput</h1>
    </div>
  );
}
